import { render, staticRenderFns } from "./Year.vue?vue&type=template&id=b7713d1c&scoped=true&"
import script from "./Year.vue?vue&type=script&lang=js&"
export * from "./Year.vue?vue&type=script&lang=js&"
import style0 from "./Year.vue?vue&type=style&index=0&id=b7713d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7713d1c",
  null
  
)

export default component.exports